import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import Button from "./Button";
import Card from "./Card";
import { validateForm } from "./Validate";
import Swal from "sweetalert2";

const SignIn = () => {
  const [formData, setFormData] = useState({
    phone: "",
  });

  const [adminName, setAdminName] = useState("");

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData, ["phone"]);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (formData.phone) {
        const response = await axios.post("/member/check_member_for_login", {
          contact_number: formData.phone,
        });

        if (response.data.exists) {

          const { token, member_id, lom ,id} = response.data; 

          if (token) {
            sessionStorage.setItem("authToken", token); 
          }
          sessionStorage.setItem("mobile", btoa(formData.phone)); 
          sessionStorage.setItem("member_id", member_id); 
          sessionStorage.setItem("lom", lom); 
 
          Swal.fire({
            icon: "success",
            title: "OTP Sent!",
            text: `An OTP has been sent to your mobile number.`,
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/OtpSignin");
          });
        } else {
          Swal.fire({
            icon: "info",
            title: "Mobile Number Not Found",
            text: "Please create an account first.",
            confirmButtonText: "Sign Up",
          });
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Missing Field!",
          text: "Please Enter the Mobile Number",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        Swal.fire({
          icon: "warning",
          title: "Mobile Number Not Found",
          text:
            error.response.data.message ||
            "Mobile number not found. Please try again.",
          confirmButtonText: "OK",
        });
      } else {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred. Please try again.",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* Background Image */}
      <img
        src={`${process.env.PUBLIC_URL}/bg_image.jpg`}
        alt="Background"
        className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
      />
      {/* Gray Overlay */}
      <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
      {/* Content */}
      <div className="relative min-h-screen flex items-center justify-center z-20">
        <Card>
          <img
            src={`${process.env.PUBLIC_URL}/jci_logo.png`}
            alt="Logo"
            className="w-24 mx-auto mb-6"
          />
          <h2 className="card-header">Login to your account</h2>
          <form onSubmit={handleSignIn} className="card-body">
            <InputField
              label="Mobile Number"
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="9087562345"
              required
              error={errors.phone}
            />
            <Button label="GET OTP" type="submit" />
          </form>
          {/* Conditional Rendering of Sign Up Link */}
          <p className="text-center mt-6">
            Don’t have an account?{" "}
            <Link to="/SignUp" className="text-blue-500 font-bold">
              Sign Up
            </Link>
          </p>
          <p className="text-center text-sm text-gray-500 mt-2">
            <span className="text-red-600">* </span>Sign-up is restricted to{" "}
            <span className="font-bold text-gray-700">zone trainers</span> only.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default SignIn;
